import { Adresse } from './adresse';
export const statuts = ['SA', 'SARL', 'EURL', 'Autre'];
export const civilities = ['M.', 'Mme'];
export const fonctions = ['Dirigeant', 'Directeur', 'Negociateur'];;
export class Signataire {
    id: number;
    ines_id: number;
    civilite: string;
    nom: string;
    prenom: string;
    email: string;
    tel: string;
    fonction: string;
}
export class Societe {
     id: number;
     document_id: number;
     commercial_id: number;
     signataire_id: number;
     ines_id: number;
     statut: string;
     raisonsociale: string;
     enseigne: string;
     siret: number;
     adresse: Adresse[];
     googleplace_id: number;
     urlsite: string;
     email: string;
     tel: string;
     fax: string;
     facturation: number;
     signataire: Signataire;
}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/models/societe.ts